import PropTypes from 'prop-types'
import React from 'react'
import { FormattedMessage } from 'react-intl'
import CharField from 'components/forms/CharField/CharField'

export default function NameField ({ defaultValue, disabled, required, name }) {
  return (
    <CharField
      name={name}
      required={required}
      disabled={disabled}
      defaultValue={defaultValue}
      labelComponent={(
        <FormattedMessage
          id='premium.checkout.card_holders_name'
          defaultMessage='Card holder&apos;s name'
        />
      )}
      errorComponent={(
        <FormattedMessage
          id='premium.checkout.card_holders_name_error'
          defaultMessage='Name is required'
        />
      )}
    />
  )
}

NameField.propTypes = {
  defaultValue: PropTypes.string,
  disabled: PropTypes.bool,
  required: PropTypes.bool,
  name: PropTypes.string,
}
